import React from 'react';
import { Field } from 'redux-form';
import { NumberInput, ReferenceArrayInput, SelectInput, SelectArrayInput, TextInput } from 'react-admin';
import { required } from 'react-admin';
import { createStyles, withStyles } from '@material-ui/core/styles';

import AuctionTypes from '../StaticData/AuctionTypes';
import CommonSettings from '../../../../Common/Partials/Settings';
import PaceInputs from '../../../../Common/Partials/PaceInputs';
import PriceCurrencies from '../StaticData/PriceCurrencies';
import ValidateBidFloor from '../Helpers/ValidateBidFloor';
import ValidateIdentifier from '../Helpers/ValidateIdentifier';

const ValidateRequired = required();

const styles = createStyles({
  bidders: {
    minWidth: 180
  },
  bidfloor: {
    display: 'inline-block'
  },
  identifier: {
    width: '100%'
  }
});

type Props = {
  classes: any,
  permissions: any,
  record: any,
  resource: string
};

const SettingsTab = (props: Props) => (
  <div style={{ paddingTop: 20 }}>
    <CommonSettings permissions={props.permissions} resource={props.resource} record={props.record} />

    <div style={{ display: 'flex', paddingTop: 20 }}>
      <div style={{ flex: 1, paddingRight: 15 }}>
        <Field name="bidder_pmp_attributes.bidder_ids" source="bidder_pmp_attributes.bidder_ids" component={ReferenceArrayInput} label="Bidders *" resource="campaign_pmps" reference="helpers/bidder_accounts" sort={{ field: 'name', order: 'ASC' }} filter={{ selectable_for_pmp_deals: true }} className={props.classes.bidders} allowEmpty record={props.record}>
          <Field name="bidder_pmp_attributes.bidder_ids" source="bidder_pmp_attributes.bidder_ids" label="Bidders" component={SelectArrayInput} validate={ValidateRequired} />
        </Field><br />
        <Field name="bidder_pmp_attributes.bidfloor" source="bidder_pmp_attributes.bidfloor" component={NumberInput} label="Deal Floor Price *" validate={ValidateBidFloor} className={props.classes.bidfloor} /><br />
        <Field name="bidder_pmp_attributes.priceScale" source="bidder_pmp_attributes.priceScale" component={NumberInput} label="Price Scale %" /><br />
        <Field name="bidder_pmp_attributes.auction_type" source="bidder_pmp_attributes.auction_type" component={SelectInput} label="Auction Type *" validate={ValidateRequired} choices={AuctionTypes} />
      </div>
      <div style={{ flex: 1, paddingLeft: 15 }}>
        <Field name="bidder_pmp_attributes.identifier" source="bidder_pmp_attributes.identifier" component={TextInput} label="Deal ID *" validate={ValidateIdentifier} className={props.classes.identifier} /><br />
        <Field name="bidder_pmp_attributes.bidfloorcur" source="bidder_pmp_attributes.bidfloorcur" component={SelectInput} label="Deal Floor Price Currency" validate={ValidateRequired} choices={PriceCurrencies} /><br />
        <PaceInputs />
      </div>
    </div>
  </div>
);

export default withStyles(styles)(SettingsTab);



// WEBPACK FOOTER //
// ./src/views/Components/Campaigns/Pmp/Partials/SettingsTab.tsx